class Reviewer {
  constructor (id, userPk, name, profileType, profileTypeDisplay) {
    this.profileId = id
    this.userPk = userPk
    this.name = name
    this.profileType = profileType
    this.profileTypeDisplay = profileTypeDisplay
  }

  static asReviewers (json) {
    return json.map(item => {
      return Reviewer.asReviewer(item)
    })
  }

  static asReviewer (json) {
    return new Reviewer(
      json.id,
      json.user_pk,
      json.fullname ? json.fullname : json.name,
      json.profile_type,
      json.profile_type_display
    )
  }
}

export {
  Reviewer
}
